export default __webpack_public_path__ + "static/media/icon-patient-tableau.2964295e.svg";